import { useState, Fragment } from "react";
import { Box, Drawer, Button } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { HiMenuAlt2 } from "react-icons/hi";
import { AiOutlineUser, AiOutlineHome, AiOutlineMail } from "react-icons/ai";
import { BiSearch, BiExit } from "react-icons/bi";
import { TbMessageCircle2 } from "react-icons/tb";
import { FiUsers } from "react-icons/fi";
import { useAuth } from "../hooks";
import { setBackIcon } from "../slice";
import Navlink from "./Navlink";
import { PALETTE } from "../Theme/Palette";

function MenuDrawer({ onOpenConfirmModal = () => {} }) {
  const dispatch = useDispatch();
  const { signOut } = useAuth();
  const [state, setState] = useState(false);
  const { data, userInfo } = useSelector((state) => state.UserCurrentState);

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const handleSearchAndCandidateAccess = () => {
    let accessCodes = [65, 70, 8, 50];
    return !accessCodes.includes(parseInt(data?.code));
  };

  const list = (anchor) => (
    <Box
      sx={{ width: 280 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Box
        sx={{
          background:
            parseInt(userInfo.genderTypeEnum) === 1 ? PALETTE.maleGradient : PALETTE.femaleGradient,
          minHeight: "100vh",
          textAlign: "right",
          boxSizing: "border-box",
          py: 2,
          px: 1,
        }}
      >
        <Navlink name="صفحه اول" href="/home" activationUrl="home" Icon={AiOutlineHome} />
        <Navlink
          name="اطلاعات من"
          href="/personal-info/base-info"
          activationUrl="personal-info"
          Icon={AiOutlineUser}
        />
        {/* <Navlink
          name="تست های روانشناسی"
          href="/tests"
          activationUrl="tests"
          icon={BiNotepad}
        /> */}
        <Navlink name="پیام ها" href="/messages" activationUrl="messages" Icon={TbMessageCircle2} />
        <Navlink
          name="پیگیری ها و پاسخگویی"
          href="/ticketing"
          activationUrl="ticketing"
          Icon={AiOutlineMail}
        />
        {/* <Navlink
          name="آموزش و مشاوره"
          href="/consulting"
          activationUrl="consulting"
          icon={FaGraduationCap}
        /> */}
        {/* <Navlink
          name="سوالات متداول"
          href="/questions"
          activationUrl="questions"
          icon={TbBook}
        /> */}
        <Navlink
          name="جستجو و کاندیدها"
          href="/search-candidates"
          activationUrl="search-candidates"
          Icon={BiSearch}
          disabled={handleSearchAndCandidateAccess()}
        />
        <Navlink name="اصلاح پروفایل" href="/profile" activationUrl="profile" Icon={FiUsers} />
        {/* <Navlink
          name="درخواست مشاوره "
          href="/consultation-request"
          activationUrl="consultation-request"
          icon={BiPhone}
        /> */}
        <Navlink
          name="خروج"
          href="/log-out"
          activationUrl="log-out"
          onClick={() => {
            dispatch(setBackIcon(false));
            onOpenConfirmModal(true);
          }}
          Icon={BiExit}
        />
      </Box>
    </Box>
  );

  return (
    <Fragment key="left">
      <Button
        sx={{ padding: "0.5rem", minWidth: 0, float: "left" }}
        onClick={toggleDrawer("left", true)}
      >
        <HiMenuAlt2 fontSize="20px" color="#999999" />
      </Button>
      <Drawer
        anchor="left"
        open={state["left"]}
        onClose={toggleDrawer("left", false)}
        sx={{ display: { xs: "block", sm: "block", md: "none" } }}
      >
        {list("left")}
      </Drawer>
    </Fragment>
  );
}

export default MenuDrawer;
